/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';

  /**
   * Общий вью для списка айтемов на страницах на REST.
   * Здесь методы для работы с роутером.
   */
  app.RestCommonView = app.View.extend({
    /**
     * Типы сортировок, в которых возможно изменение порядка.
     * @type {Array}
     */
    sortTypesWithOrder: ['-price', '-price-unit', '-price_delivery', '-supply_period'],

    /**
     * Количество времени в миллисекундах, затрачиваемое на анимацию прокрутки страницы.
     * @type {number}
     */
    scrollAnimationTime: 1000,

    /**
     * Класс для определения точки прокрутки
     */
    scrollHolderClass: '.catalog-holder',

    /**
     * @inheritDoc
     */
    additionalOptions: ['scrollHolderClass'],

    /**
     * @inheritDoc
     */
    beforeRun: function () {
      this.infinitePreloader = new app.PreloaderView();
      this.listenTo(Backbone, 'toggle-mobile-filters', this.toggleFilters);
      this.listenTo(Backbone, 'apply-sort', this.changeSort);
      this.listenTo(Backbone, 'apply-viewtype', this.changeViewType);
    },

    /**
     * @inheritDoc
     */
    afterRun: function () {
      this.listenToRender([]);
    },

    /**
     * Создаем два массива - показываемых и не показываемых сортировок.
     * @param {String} activeSort
     */
    extractShownSortTypes: function (activeSort) {
      var that = this,
        sortTypes = this.model.sortTypes,
        filteredSortTypes,
        filteredSort;
      filteredSort = this.filterSortParam(activeSort);
      this.userChosenSortType = app.helpers.CookieHelper.getCookie(this.jsView + '-sort-types') || filteredSort;
      filteredSortTypes = _.take(
        _.difference(sortTypes.filter(function (sort) {
          return !(sort === 'discount' && !that.model.state.hasDiscountItems);
        }), this.sortTypesWithOrder),
        this.shownSortThreshold
      );
      if (_.includes(filteredSortTypes, filteredSort)) {
        if (_.includes(filteredSortTypes, this.userChosenSortType)) {
          this.showSortTypes = filteredSortTypes;
        } else {
          this.showSortTypes = this.changeMutableSortType(filteredSortTypes, this.userChosenSortType);
        }
      } else {
        this.showSortTypes = this.changeMutableSortType(filteredSortTypes, filteredSort);
      }
      this.moreSortTypes = sortTypes.filter(function (sort) {
        return !_.includes(that.showSortTypes, sort);
      });
    },

    /**
     * Подменяем изменяемую сортировку.
     * @param sortTypes
     * @param sort
     * @returns {array}
     */
    changeMutableSortType: function (sortTypes, sort) {
      var result = _.take(sortTypes, sortTypes.length - 1);
      result.push(sort);
      return result;
    },

    /**
     * Убираем "-" из параметра сортировки для сортировок с возможностью изменения порядка.
     * @param {string} sort
     * @returns {string}
     */
    filterSortParam: function(sort) {
      return  _.includes(this.sortTypesWithOrder, sort) ? sort.replace(/^-/, '') : sort;
    },

    /**
     * Сохраняем в куку сортировку выбранную пользователем.
     * @param {string} sort
     */
    saveSortTypeToCookie: function (sort) {
      if (!app.isMobile && this.shownSortThreshold && this.showSortTypes) {
        var filteredSort = this.filterSortParam(sort),
          immutableSorts = _.take(this.showSortTypes, this.showSortTypes.length - 1);
        if (!_.includes(immutableSorts, filteredSort)) {
          app.helpers.CookieHelper.setCookie(this.jsView + '-sort-types', filteredSort, {
            domain: '.' + app.helpers.UrlHelper.getDomain(),
            path: '/',
          });
        }
      }
    },

    /**
     * Показываем/скрываем попап с опциями
     * @param {Event} e Событие
     */
    toggleOptionsPopup: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $currentTarget = this.$(e.currentTarget);
      var optionName = $currentTarget.data('option-name');
      var shouldPopupOpen = $currentTarget.find('.js-options-popup').hasClass('not_display');
      this.hideOptionsPopup(null);
      if (shouldPopupOpen) {
        this.$('.popup-' + optionName).toggleClass('not_display');
        this.$('.icon-' + optionName).toggleClass('with-icon_arrowup-blue with-icon_arrowdown-blue')
          .toggleClass('with-icon_arrowup with-icon_arrowdown');
      }
    },

    /**
     * Скрываем попап с опциями
     * @param {Event} [e]
     */
    hideOptionsPopup: function (e) {
      var $target = null;
      var isOutsideClick = false;
      if (e) {
        $target = $(e.target);
        isOutsideClick = !($target.parents('.js-options-popup').length || $target.hasClass('.js-options-popup'));
      }
      if (this.$('.js-options-popup').length && (!$target || $target && isOutsideClick)) {
        this.$('.js-options-popup').addClass('not_display');
        this.$('.icon-options').addClass('with-icon_arrowdown-blue')
          .addClass('with-icon_arrowdown');
        this.$('.icon-options').removeClass('with-icon_arrowup-blue')
          .removeClass('with-icon_arrowup');
      }
    },

    /**
     * Изменение параметра сортировки
     * @param {Event} e
     */
    changeSort: function (e) {
      e.stopPropagation();
      var sort = $(e.target).data('sort'),
        sortRus = $(e.target).html();
      /**
       *  Если пункт сортировки отключен, не обрабатываем клик
       */
      if ($(e.target).hasClass('disabled-filter')) {
        return;
      }
      this.hideOptionsPopup();
      if (app.isMobile) {
        this.showSort();
      }
      this.saveSortTypeToCookie(sort);
      this.pushDataToDataLayer('sort', sort, sortRus);
      this.router.navigate(this.router.getPathFragment(), {
        trigger: true,
      }, {
        'sort': sort,
      });
    },

    /**
     * Изменения параметра количества товаров на странице
     * @param {Event} e
     */
    changePageSize: function (e) {
      var pageSize = $(e.target).data('pagesize'),
        mode = $(e.target).data('mode'),
        newCurrentPage = this.model.getCurrentPageByPageSize(pageSize),
        fragment = this.router.getPathFragment();
      if (newCurrentPage !== this.model.state.currentPage) {
        fragment = '/p' + newCurrentPage;
        if (newCurrentPage === 1) {
          fragment = '/';
        }
      }
      if (mode === 'infinite') {
        fragment = '/';
      }
      var params = {
        'per-page': pageSize,
      };
      if (this.model.mode !== mode) {
        params.mode = mode;
      }
      e.stopPropagation();
      this.hideOptionsPopup();
      this.router.navigate(fragment, {
        trigger: true,
      }, params);
    },

    /**
     * Изменение типа внешнего вида товара.
     * @param {Event} e
     */
    changeViewType: function (e) {
      var viewType = $(e.target).data('viewtype');
      this.pushDataToDataLayer('viewtype', viewType);
      this.router.navigate(this.router.getPathFragment(), {
        trigger: true,
      }, {
        'viewtype': viewType,
      });
    },

    /**
     * Изменение типа внешнего вида товара для мобильной версии
     * @param {Event} e
     */
    changeViewTypeOnMobile: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = this.$(e.currentTarget);
      if ($el.hasClass('selected')) {
        return;
      }
      this.$('.js-viewtype').removeClass('selected');
      this.$('.js-viewtype[data-viewtype="' + $el.data('viewtype') + '"]').toggleClass('selected');
      Backbone.trigger('apply-viewtype', e);
    },

    /**
     * Обработка изменившихся через роутер параметров.
     * @param {Array} changedKeys Массив ключей измененных параметров роутера.
     */
    choice: function (changedKeys) {
      if (this.newLoader) {
        this.newLoader.render();
      } else {
        app.preloader.render();
      }
      if (_.includes(changedKeys, 'f')) {
        this.changeCategoryWrapper();
      }
      this.listenToRender(changedKeys);
      this.childViews.itemsView.updateGridButtons();
      this.$('#c12345').prop('checked', false);
      this.infiniteRender(changedKeys);
    },

    /**
     * Подписывает прокрутку к необходимой точке страницы при изменении параметров роутера.
     * @param {Array} changedKeys Массив ключей измененных параметров роутера.
     */
    listenToRender: function (changedKeys) {
      var chosenItemKey = this.getChosenItemStorageKey();
      var hasChosenItemId = Boolean(app.helpers.StorageHelper.SS.get(chosenItemKey));
      var pageIsChanged = _.includes(changedKeys, 'page');
      var listener = null;
      if (pageIsChanged && !hasChosenItemId) {
        listener = this.scrollToTop;
      } else {
        listener = this.scrollToChosenItem;
      }
      this.stopListening(this.childViews.itemsView, 'rendered', this.scrollToTop);
      this.stopListening(this.childViews.itemsView, 'rendered', this.scrollToChosenItem);
      this.listenToOnce(this.childViews.itemsView, 'rendered', listener);
    },

    /**
     * Прокручивает страницу к началу списка товаров.
     */
    scrollToTop: function () {
      var $holder = this.$(this.scrollHolderClass);
      var holderOffset = $holder.offset();
      if (holderOffset) {
        this.scrollTo(holderOffset.top);
      }
    },

    /**
     * Прокручивает страницу к выбранному ранее в течение сессии товару.
     * Выбранный товар - тот, на страницу которого перешли со страницы каталога.
     */
    scrollToChosenItem: function () {
      var chosenItemStorageKey = this.getChosenItemStorageKey();
      var chosenItemId = app.helpers.StorageHelper.SS.get(chosenItemStorageKey);
      if (chosenItemId) {
        var $chosenItem = this.$('.catalog [data-key=' + chosenItemId + ']');
        var $chosenModifier = this.$('[data-modifier=' + chosenItemId + ']').closest('.tile');
        if ($chosenItem.length > 0) {
          this.scrollTo($chosenItem.offset().top);
        } else if ($chosenModifier.length > 0) {
          this.scrollTo($chosenModifier.offset().top);
        }
        app.helpers.StorageHelper.SS.remove(chosenItemStorageKey);
      }
    },

    /**
     * Прокручивает страницу до заданной точки.
     * @param {number} scrollTop Позиция, до которой будет прокручена страница.
     */
    scrollTo: function (scrollTop) {
      if (scrollTop && !isNaN(scrollTop) && isFinite(scrollTop)) {
        if (app.isTerminal) {
          var headerHeight = $('.header_fixed').height() || 0;
          scrollTop -= headerHeight;
        }
        $('html, body').animate({
          scrollTop: scrollTop,
          duration: this.scrollAnimationTime,
        });
      }
    },

    /**
     * Возвращает ключ значения в хранилище сессии для идентификатора выбранного в течении сессии товара в каталоге.
     * @returns {string} Ключ значения в хранилище сессии.
     */
    getChosenItemStorageKey: function () {
      var prefix = app.SESSION_CHOOSED_ITEM_ID_PREFIX;
      var fullPath = location.origin + location.pathname;
      return prefix + fullPath;
    },

    /**
     * Отправка параметров страницы в dataLayer при смене сортировки/вида отображения.
     * @param type - тип события
     * @param value - значение измененного параметра
     * @param valueRus
     */
    pushDataToDataLayer: function (type, value, valueRus) {
      var data = '';
      if (type === 'sort') {
        data = valueRus.replace('По ', '');
        data = data.replace(/\s{2,}/g, '');
        if (value === 'rank') {
          data = 'rank';
        }
        if (value === '-price') {
          data = 'убыванию цены';
        }
        if (value === 'price') {
          data = 'возрастанию цены';
        }
        dataLayer.push({
          sort: data,
        });
      }
      if (type === 'viewtype') {
        if (value === 'list') {
          data = 'table';
        } else {
          data = value;
        }
        dataLayer.push({
          show_view: data,
        });
      }
    },

    /**
     * Вызывает событие 'InfiniteScroll'.
     */
    infiniteScroll: function () {
      var that = this,
        $infinityScrollData = $('.infinityScrollData');
      this.listenTo(app.mainWindow, 'window.scroll', function () {
        // Проверяем пользователя, находится ли он в нижней части страницы
        if (that.model.mode === 'infinite' && !that.preventScroll && $(window).scrollTop() + $(window).height() >= $infinityScrollData.offset().top + $infinityScrollData.height()) {
          // нужно для того, чтобы при первоначальной загрузке с положением в самом низу страницы можно было проскроллить
          if (that.model.fetchCounter > 1) {
            that.togglePreventScroll(true);
          }
          that.trigger('InfiniteScroll');
        }
      });
    },

    /**
     * Заполнение коллекции при бесконечном скролле.
     */
    fetchScroll: function () {
      if (this.model.state.currentPage < this.model.state.lastPage && this.model.hasNextPage()) {
        this.model.getNextPage({
          remove: false,
        });
        this.model.isScroll = true;
      }
    },

    /**
     * Переключение блокировки фетча при скролле
     * @param state
     */
    togglePreventScroll: function (state) {
      if (arguments.length) {
        this.preventScroll = !!state;
      } else {
        this.preventScroll = !this.preventScroll;
      }
    },

    /**
     * Показ прелоадера при бесконечном скролле
     */
    renderInfinitePreloader: function () {
      var qtyShown = this.model.length,
        qtyTotal = this.model.state.totalRecords,
        currentPage = this.model.state.currentPage,
        lastPage = this.model.state.lastPage;
      if (currentPage < lastPage) {
        this.infinitePreloader.render(qtyShown, qtyTotal);
      }
    },

    /**
     * Показ и скрытие фильтров
     */
    toggleFilters: function (isVisible) {
      $('body').toggleClass('filter-opened', isVisible);
      this.$('.filter_but').toggleClass('active', isVisible);
      this.$('.catalog-filter').toggleClass('active', isVisible);
      this.$('.js-filters-list').toggleClass('not_display', !isVisible);
      app.preloader.remove();
    },
  });
})();

}.call(window));